/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var EntityPermissionsType;
(function (EntityPermissionsType) {
    EntityPermissionsType["SheetRow"] = "SHEET_ROW";
    EntityPermissionsType["Document"] = "DOCUMENT";
    EntityPermissionsType["Tag"] = "TAG";
})(EntityPermissionsType || (EntityPermissionsType = {}));
export function EntityPermissionsTypeFromJSON(json) {
    return EntityPermissionsTypeFromJSONTyped(json, false);
}
export function EntityPermissionsTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function EntityPermissionsTypeToJSON(value) {
    return value;
}
